module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-dusty-rose-5-7a6a3f8ecce37e38bc6be39a2830f039.png";